var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{staticClass:"background-listing",attrs:{"span":24}},[_c('el-row',[_c('el-col',{staticStyle:{"display":"flex","flex-direction":"row","padding":"2px"},attrs:{"span":24}},[_c('span',{staticClass:"u-connect-p"},[_vm._v("Australia's New Address for the Best in New Properties")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-033b93fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/newPropertiesSection.vue
// module id = null
// module chunks = 